import request from "./axios";

function index(params) {
  return request({
    method: "get",
    url: `/contacts`,
    params: params
  })
}

function get(id) {
  return request({
    method: "get",
    url: `/contacts/${id}`,
  })
}

function create(params) {
  return request({
    method: "post",
    url: `/contacts`,
    data: { contact: params }
  })
}

function update(id, params) {
  return request({
    method: "patch",
    url: `/contacts/${id}`,
    data: { contact: params }
  })
}

const ContactsService = {
  index, update, get, create
};

export default ContactsService;
